import { Input } from 'antd'
import { AdminsLoyaltyGetVoucherListResponseItem } from 'generated/api'
import { IFilter, qucikVoucherTags } from 'constants/tags'
import VoucherTable from './VoucherTable'
import Card from 'components/card/Card'
import Pagination from 'components/pagination/Pagination'
import { IconSearch } from 'components/icons'
import Errors from 'components/errors/Errors'
import { VoucherStatusEnum } from '../hooks/useVoucher'
import CardHeaderVouchers from './CardHeaderVouchers'
import VoucherTags from './VoucherTags'

interface IVoucherIndexProps {
  fetchStatus: 'loading' | 'success' | 'failed'
  vouchers: AdminsLoyaltyGetVoucherListResponseItem[]
  totalRow: number
  page: number
  limit: number
  keywordSearch: string
  onChangePage: (page: number) => void
  onChangeLimit: (limit: number) => void
  onChangeKeywordSearch: (value: string) => void
  onEnterKeywordSearch: () => void
  onChangeVoucherStatus: (status: VoucherStatusEnum) => void
  onFetch: () => void
  selectedTag: IFilter[]
  onSelectTag: (selectFilter: IFilter) => void
  onOpenModalTags: (status: boolean) => void
  onOpenModalCancel: (voucher: AdminsLoyaltyGetVoucherListResponseItem) => void
}

export default function VoucherIndex(props: IVoucherIndexProps) {
  const {
    fetchStatus,
    vouchers,
    totalRow,
    page,
    limit,
    keywordSearch,
    onChangePage,
    onChangeLimit,
    onChangeKeywordSearch,
    onEnterKeywordSearch,
    onChangeVoucherStatus,
    onFetch,
    selectedTag,
    onSelectTag,
    onOpenModalTags,
    onOpenModalCancel,
  } = props

  const isLoading = fetchStatus === 'loading'
  const isFailed = fetchStatus === 'failed'
  const isSuccess = fetchStatus === 'success'

  return (
    <Card
      loading={isLoading}
      dataTestId="card-vouchers"
      spinnerTestId="card-spinner-vouchers"
      className="rounded-xl p-4"
    >
      {isFailed ? (
        <Errors
          dataTestId="vouchers"
          inverse={false}
          button={true}
          header="Mohon maaf, permintaan Anda tidak dapat diproses."
          paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
          buttonLabel="Coba lagi"
          buttonAction={onFetch}
        />
      ) : null}

      {isSuccess || isLoading ? (
        <div data-testid="success-container-vouchers">
          <Card.Header className="flex-col">
            <CardHeaderVouchers
              title="Kelola Voucher"
              labelButton="Buat Voucher"
              navigateTo="/loyalty/vouchers/create"
              onChangeTab={onChangeVoucherStatus}
            />
          </Card.Header>
          <Card.Body className="mt-0">
            <div className="flex flex-col gap-4">
              <div className="xl:flex xl:gap-4">
                <div className="xl:w-2/5 mb-4 xl:mb-0">
                  <Input
                    prefix={<IconSearch />}
                    className="input-search"
                    data-testid="input-search-vouchers"
                    placeholder="Cari Voucher di sini"
                    value={keywordSearch}
                    onChange={e => onChangeKeywordSearch(e.target.value)}
                    onPressEnter={onEnterKeywordSearch}
                  />
                </div>
                <div className="xl:w-3/5">
                  <VoucherTags
                    Tags={qucikVoucherTags}
                    selectedTags={selectedTag}
                    onOpenModalTags={onOpenModalTags}
                    onSelectTag={onSelectTag}
                  />
                </div>
              </div>
              <VoucherTable data={vouchers} onClickCancelModal={onOpenModalCancel} />
            </div>
          </Card.Body>
          <Card.Footer>
            <div className="px-4 py-3">
              <Pagination
                setLimit={(limit: number) => onChangeLimit(limit)}
                onPageChanged={(page: number) => onChangePage(page)}
                totalRows={totalRow}
                currentPage={page}
                limit={limit}
                showLimitPage={true}
              />
            </div>
          </Card.Footer>
        </div>
      ) : null}
    </Card>
  )
}
